import { useState } from "react";

import ImageVideoText from "components/sections/ImageVideoText";
import HorizontalTechSpecs from "components/sections/HorizontalTechSpecs";
import TextImageColumns from "components/sections/TextImageColumns";
import TextColumns from "components/sections/TextColumns";
import ImageSection from "components/sections/ImageSection";
import DarkQuoteSection from "components/sections/DarkQuoteSection";
import TextHeader from "components/sections/TextHeader";
import NavFooter from "components/sections/NavFooter";
import MainContainer from "components/sections/MainContainer";
import FloatingCTA from "components/blocks/FloatingCTA";
import MetaHead from "components/base/MetaHead";
import Trans from "components/base/Trans";
import { useShowCTA } from "utils/hooks";

export default function DigitalCockpit() {
  const [lastSectionVisible, setLastSectionVisible] = useState(false);
  const { headerRef, showCTA } = useShowCTA(lastSectionVisible);

  return (
    <MainContainer
      navStyle={{ gradient: false, inverted: false }}
      updateVisible={setLastSectionVisible}
    >
      <MetaHead
        title="LBL_HDC_META_TITLE"
        description="LBL_HDC_META_DESC"
        imageUrl="/images/meta/hdc.jpg"
      />
      <div ref={headerRef}>
        <TextHeader
          page={<Trans id="LBL_HDC_PAGE_TITLE" />}
          title={<Trans id="LBL_HDC_TITLE" />}
          description={<Trans id="LBL_HDC_DESCRIPTION" />}
          inverted
        />
      </div>
      <HorizontalTechSpecs
        image="/images/hdc/header.jpg"
        video={{
          stream: {
            type: "hls",
            data: "https://vz-49830c06-001.b-cdn.net/18b25e41-1da1-4673-9d65-7207f96603c2/playlist.m3u8",
          },
          metadata: {
            video_title: "Hill Helicopters digital cockpit Video",
            video_id: "hdc-video",
          },
        }}
        specs={[
          { text: <Trans id="LBL_HDC_SPEC_1" /> },
          { text: <Trans id="LBL_HDC_SPEC_2" /> },
          { text: <Trans id="LBL_HDC_SPEC_3" values={{ br: <br /> }} /> },
          { text: <Trans id="LBL_HDC_SPEC_4" values={{ br: <br /> }} /> },
          { text: <Trans id="LBL_HDC_SPEC_5" /> },
        ]}
      />

      <DarkQuoteSection
        title={<Trans id="LBL_HDC_EXPERIENCE_TITLE" />}
        description={<Trans id="LBL_HDC_EXPERIENCE_DESCRIPTION" />}
      />
      <TextColumns
        title={<Trans id="LBL_HDC_REDEFINE_TITLE" />}
        description={<Trans id="LBL_HDC_REDEFINE_DESCRIPTION" />}
      />
      <ImageVideoText
        pt={0}
        pb="xl"
        animationId="it-1"
        title={<Trans id="LBL_HDC_VFR_CAPTION_1" />}
        description={<Trans id="LBL_HDC_VFR_DESCRIPTION_1" />}
        image="/images/hdc/header.jpg"
        inverted
      />
      <TextImageColumns
        isInverted
        topTitle={<Trans id="LBL_HDC_IPI_TITLE" />}
        topDescription={<Trans id="LBL_HDC_IPI_DESCRIPTION" />}
        topImage="/images/hdc/img-hdc-02.jpg"
        bottomTitle={<Trans id="LBL_HDC_IPAD_TITLE" />}
        bottomDescription={<Trans id="LBL_HDC_IPAD_DESCRIPTION" />}
        bottomImage="/images/hdc/img-hdc-03.jpg"
        pb={0}
      />
      <TextImageColumns
        pt={[0, null, "xxxl"]}
        isInverted
        topTitle={<Trans id="LBL_HDC_OPTIMISE_TITLE" />}
        topDescription={<Trans id="LBL_HDC_OPTIMISE_DESCRIPTION" />}
        topImage="/images/hdc/img-hdc-04.jpg"
      />
      <ImageVideoText
        pb="xl"
        pt="xl"
        video={{
          stream: {
            type: "hls",
            data: "https://vz-49830c06-001.b-cdn.net/765b4cc9-9a93-4163-9d54-8f1824735c5d/playlist.m3u8",
          },
          metadata: {
            video_title: "Hill Helicopters digital cockpit Video",
            video_id: "hdc-video-2",
          },
        }}
        inverted
        animationId="it-2"
        title={<Trans id="LBL_HDC_PILOT_CAPTION_1" />}
        description={<Trans id="LBL_HDC_PILOT_DESCRIPTION_1" />}
        image="/images/hdc/img-hdc-05.jpg"
      />
      <TextImageColumns
        isInverted
        topTitle={<Trans id="LBL_HDC_HAPTIC_TITLE" />}
        topDescription={<Trans id="LBL_HDC_HAPTIC_DESCRIPTION" />}
        topImage="/images/hdc/img-hdc-07.jpg"
        bottomTitle={<Trans id="LBL_HDC_HASM_TITLE" />}
        bottomDescription={<Trans id="LBL_HDC_HASM_DESCRIPTION" />}
        bottomImage="/images/hdc/img-hdc-08.jpg"
      />
      <TextImageColumns
        isInverted
        pt={[0, null, "xxxl"]}
        topTitle={<Trans id="LBL_HDC_CONNECTIVITY_CAPTION_1" />}
        topDescription={<Trans id="LBL_HDC_CONNECTIVITY_DESCRIPTION_1" />}
        topImage="/images/hdc/img-hdc-09.jpg"
      />
      <TextColumns
        animationId="anim5"
        image="/images/hdc/img-disti.png"
        imageHeight={["50px", null, "80px"]}
        imageWidth={["50%", null, "100%"]}
        title={<Trans id="LBL_HDC_RIGHTWARE_TITLE" />}
        description={<Trans id="LBL_HDC_RIGHTWARE_DESCRIPTION" />}
      />
      <ImageSection image="/images/hdc/img-hdc-10.jpg" bg="black.700" />

      <DarkQuoteSection
        title={<Trans id="LBL_HDC_ATTAINABLE_TITLE" />}
        description={<Trans id="LBL_HDC_ATTAINABLE_DESCRIPTION" />}
      />
      <NavFooter
        previous={<Trans id="LBL_MENU_GA2" />}
        pathPrevious="/general-aviation-20"
        bgPrevious="/images/nav-footer/ga.jpg"
        next={<Trans id="LBL_MENU_TECH_SPECS" />}
        pathNext="/tech-specs"
        bgNext="/images/nav-footer/tech-specs.jpg"
      />
      <FloatingCTA show={showCTA} />
    </MainContainer>
  );
}
